import flavia03 from "../images/flavia03.jpeg";

function About() {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="grid md:grid-cols-2 gap-12 items-start mb-12">
        <div>
          <h1 className="text-5xl font-bold mb-8">About Me</h1>
          <div className="prose prose-lg">
            <p className="text-xl mb-6">
              With over a decade of dedication to classical piano, I bring
              timeless compositions to life through passionate and technically
              precise performances.
            </p>
          </div>
        </div>
        <div>
          <img
            src={flavia03}
            alt="Flavia Karla Amado León"
            className="w-full rounded-lg shadow-2xl"
          />
        </div>
      </div>

      <div className="space-y-12">
        <div>
          <h2 className="text-3xl font-serif mb-4">Musical Journey</h2>
          <p className="text-piano-black/80 mb-4">
            My journey in classical piano began at the age of eight, inspired by
            my mother, who is a pianist and piano teacher. I studied under
            renowned instructors and performed at prestigious venues across the
            globe. Each of my performances is a celebration of classical music's
            enduring beauty and emotional depth, carrying forward the musical
            legacy passed down through my family.
          </p>
        </div>

        <div className="mb-12">
          <h2 className="text-3xl font-serif mb-4">Musical Skills</h2>
          <ul className="space-y-3 text-piano-black/80">
            <li className="flex items-start">
              <span className="text-piano-black/40 mr-3">•</span>
              <span>
                Proficient in diverse musical styles including classical, jazz,
                and contemporary
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-piano-black/40 mr-3">•</span>
              <span>
                Advanced sheet music reading and improvisation abilities
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-piano-black/40 mr-3">•</span>
              <span>
                Versatile performer capable of both solo and ensemble
                performances
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-piano-black/40 mr-3">•</span>
              <span>
                Experienced piano instructor with a passion for teaching
              </span>
            </li>
          </ul>
        </div>

        <div className="mb-12">
          <h2 className="text-3xl font-serif mb-4">Professional Experience</h2>
          <div className="space-y-6 text-piano-black/80">
            <div>
              <h3 className="text-xl font-medium mb-2">Luxury Hotel Pianist</h3>
              <p className="mb-2">
                Creating elegant atmospheres as a lobby pianist in prestigious
                hotels:
              </p>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start">
                  <span className="text-piano-black/40 mr-3">•</span>
                  <div>
                    <span className="font-medium">Naga World Hotel</span>
                    <span className="mx-2">•</span>
                    <span>Phnom Penh, Cambodia (2025)</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-piano-black/40 mr-3">•</span>
                  <div>
                    <span className="font-medium">Grand Makadi Spa</span>
                    <span className="mx-2">•</span>
                    <span>Hurghada, Egypt (2024)</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-piano-black/40 mr-3">•</span>
                  <div>
                    <span className="font-medium">
                      Steigenberger Aldau Beach Hotel
                    </span>
                    <span className="mx-2">•</span>
                    <span>Hurghada, Egypt (2024)</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-piano-black/40 mr-3">•</span>
                  <div>
                    <span className="font-medium">
                      Steigenberger Pure Lifestyle
                    </span>
                    <span className="mx-2">•</span>
                    <span>Hurghada, Egypt (2024)</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-piano-black/40 mr-3">•</span>
                  <div>
                    <span className="font-medium">
                      Desert Rose & Grand Siva
                    </span>
                    <span className="mx-2">•</span>
                    <span>Dana Beach, Egypt (2024)</span>
                  </div>
                </li>
              </ul>
            </div>

            {/* <div>
              <h3 className="text-xl font-medium mb-2">Keyboard Performance</h3>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start">
                  <span className="text-piano-black/40 mr-3">•</span>
                  <div>
                    <span className="font-medium">Grand Makadi & Grand Makadi Sunwing</span>
                    <span className="mx-2">•</span>
                    <span>Hurghada, Egypt (2024, 3 months)</span>
                  </div>
                </li>
              </ul>
            </div> */}

            <div>
              <h3 className="text-xl font-medium mb-2">
                Additional Experience
              </h3>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start">
                  <span className="text-piano-black/40 mr-3">•</span>
                  <span>
                    Studio recording sessions as a professional pianist
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-piano-black/40 mr-3">•</span>
                  <span>
                    Private piano instruction for students of various skill
                    levels
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-piano-black/40 mr-3">•</span>
                  <span>
                    Regular participation in auditions and recitals since
                    childhood
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mb-12 mt-8">
          <h2 className="text-3xl font-serif mb-4">Education</h2>
          <ul className="space-y-4 text-piano-black/80">
            <li className="flex items-center">
              <span className="font-semibold mr-2">2020 - 2024:</span>
              Upper Secondary Technician in Music
              <span className="mx-2">•</span>
              National School of Arts, Havana, Cuba
            </li>
            <li className="flex items-center">
              <span className="font-semibold mr-2">2013 - 2019:</span>
              Elementary Level in Piano
              <span className="mx-2">•</span>
              Professional School of Arts Pedro Raúl Sánchez, Pinar del Río,
              Cuba
            </li>
          </ul>
        </div>

        <div className="mb-8">
          <h2 className="text-3xl font-serif mb-4">Languages</h2>
          <ul className="space-y-3 text-piano-black/80">
            <li className="flex items-center">
              <span className="text-piano-black/40 mr-3">•</span>
              <span className="font-medium">Spanish</span>
              <span className="mx-2">—</span>
              <span>Mother tongue</span>
            </li>
            <li className="flex items-center">
              <span className="text-piano-black/40 mr-3">•</span>
              <span className="font-medium">English</span>
              <span className="mx-2">—</span>
              <span>Level A2</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default About;
